import { render, staticRenderFns } from "./Layout1Component.vue?vue&type=template&id=f04f561e&scoped=true&"
import script from "./Layout1Component.vue?vue&type=script&lang=js&"
export * from "./Layout1Component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04f561e",
  null
  
)

export default component.exports